import { Fragment } from "react"

import type { ButtonProps } from "~/shared/ui/kit"
import { VSpace } from "~/shared/ui"
import { SidebarLink, type SidebarLinkProps } from "~/shared/ui/layouts/main/SidebarLink"

import cssModule from "./index.module.scss"

export type SidebarNavProps = {
	links?: SidebarLinkProps[]
	//backUrl?: string
	customization?: {
		buttonColorStyle?: ButtonProps<"a">["colorStyle"]
	} & SidebarLinkProps["customization"]
}

export function SidebarNav({
							   links = [],
							   customization = {}
						   }: SidebarNavProps) {
	return (
		<nav className={cssModule.sidebarNav}>
			<ul className={cssModule.linkList}>
				{links.map(
					(
						{ url, title, onClick, target, element, customization: linkCustomization = {} },
						index
					) =>
						element
							? <Fragment key={index}>{element}</Fragment>
							: <SidebarLink
								key={index}
								url={url}
								onClick={onClick}
								customization={{ ...customization, ...linkCustomization }}
								title={title}
								target={target} />
				)}
			</ul>
			<VSpace size={1} />
			{/*<div className="flex align-items-center h-[5.8rem] mb-[2rem]">
				<BackButton customization={customization} url={backUrl} />
			</div>*/}
		</nav>
	)
}
